import React from "react"
import {t} from "@lingui/core/macro"
import styles from "./styles.module.css"

export default function SearchBar({value, onChange}) {
    return (
        <div className={styles.searchBar}>
            <svg className={styles.searchIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <circle cx="11" cy="11" r="8"/>
                <line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input
                className={styles.searchInput}
                placeholder={t`Rechercher un article…`}
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
                type="search"
            />
        </div>
    )
}
